<template>
  <div class="monitoringdescription">
    <div class="header">
      <div class="title">智能监控硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in monitoringdescriptionList"
          :key="item.id"
        >
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import monitoringdescription1 from "../../../../assets/programme/monitoringdescription1.png";
import monitoringdescription2 from "../../../../assets/programme/monitoringdescription2.png";
import monitoringdescription3 from "../../../../assets/programme/monitoringdescription3.png";
import monitoringdescription4 from "../../../../assets/programme/monitoringdescription4.png";
import monitoringdescription5 from "../../../../assets/programme/monitoringdescription5.png";
import monitoringdescription6 from "../../../../assets/programme/monitoringdescription6.png";

export default {
  setup() {
    return reactive({
      monitoringdescriptionList: [
        {
          id: 1,
          title: "网络防爆型摄像机",
          logo: monitoringdescription1,
        },
        {
          id: 2,
          title: "网络电梯专用摄像机",
          logo: monitoringdescription2,
        },
        {
          id: 3,
          title: "网络高清球型云台摄像机",
          logo: monitoringdescription3,
        },
        {
          id: 4,
          title: "网络半球摄像机",
          logo: monitoringdescription4,
        },
        {
          id: 5,
          title: "网络抢式摄像机",
          logo: monitoringdescription5,
        },
        {
          id: 6,
          title: "高清网络摄像机",
          logo: monitoringdescription6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.monitoringdescription {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.body .list .item {
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
}
.body .list .item img {
  width: 162px;
}
.body .list .item div {
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
</style>
